import { usePage } from "@inertiajs/react";
import { PropsWithChildren, useEffect } from "react";
import toast, { Toaster as HotToast } from "react-hot-toast";
import { Toaster as SonnerToast } from "@/components/ui/sonner";
import { toast as sonner } from "sonner";

import { IntlProvider } from "react-intl";

export default function BaseLayout(props: PropsWithChildren) {
  const { children } = props;

  const { flash } = usePage<{
    flash?: {
      notice?: string;
      alert?: string;
      info?: string;
      info_description?: string;
    };
  }>().props;

  useEffect(() => {
    if (flash?.notice) {
      toast.success(flash.notice);
    }
    if (flash?.alert) {
      toast.error(flash.alert);
    }

    if (flash?.info) {
      sonner(flash.info, {
        description: flash.info_description,
      });
    }
  }, [flash]);

  return (
    <IntlProvider locale="pt-BR">
      <HotToast position="top-center" />
      <SonnerToast />

      {children}
    </IntlProvider>
  );
}
